<template>
  <div
    v-if="couponCodes[code]"
    class="tw-flex tw-flex-row tw-justify-start tw-items-center  tw-rounded-full tw-w-fit tw-px-3 tw-py-2 tw-mx-auto"
    :class="status !== 'error' ? 'tw-bg-[#F0EDFF]' : 'tw-bg-[#ff000030]'"
  >
    <div 
      v-if="loading" 
      class="tw-h-[22px] tw-w-[24px] tw-mt-[-43px] tw-ml-[-13px] tw-mr-[30px]"
    >
      <loading

        :is-full-page="false"
        :active="loading"
        color="#a783ff"
        style="position: relative; border-radius: 50%; scale: 0.4; width: 64px"
      />
    </div>
    <template v-else>
      <span
        v-if="status === 'error'"
        class="icon-error tw-bg-red-500 tw-mr-3"
      ></span>
      <img
        v-if="status !== 'error'"
        class="tw-mr-3"
        :class=" status !== 'success' && 'tw-opacity-[0.2]'"
        src="../../assets/images/svg/check.svg"
        alt="check"
      >
    </template>
    <span
      v-if="status === 'success'"
      class="tw-max-w-[700px] sub-text text-left md:tw-text-center"
    >
      Success! A <strong>{{ couponCodes[code] }}% discount</strong> will be applied to your <strong>next order</strong>.
    </span>
    <span
      v-if="status === 'pending'"
      class="tw-max-w-[700px] sub-text text-left md:tw-text-center"
    >
      Complete follow up to receive <strong>{{ couponCodes[code] }}%</strong> off your next order!
    </span>
    <span
      v-if="status === 'error'"
      class="tw-max-w-[700px] sub-text text-left md:tw-text-center"
    >
      {{ errorMessage || 'Something went wrong while processing the discount.' }}
    </span>
  </div>
</template>

<script>
import Loading from 'vue-loading-overlay';

export default {
  components: { Loading },
  props: {
    status: {
      type: String,
      default: 'pending'
    },
    code: {
      type: String,
      default: null
    },
    loading: {
      type: Boolean,
      default: false
    },
    errorMessage: {
      type: String,
      default: null
    }

  },
  data(){
    return {
      couponCodes: {
        q26u0VBb: 5,
        wdKURt95: 10,
        tAIEoOcr: 15,
        oIxMkx5a: 20,
        fWztOB7s: 25,
        '70HzOeHS': 30,
        '5vHlxTOX': 35,
        zVn6mF8m: 40,
        xqjsM7ao: 45,
        PhvXixb2: 50,
        irtPPLee: 20,
        '5Sd0V3v9': 25,
        yQHFXWbs: 30,
        qVeWvc1v: 35,
        '9VbT5Nh9': 40,
        DEVFUDISCOUNT40: 40,
        flEe1U6c: 20,
        SumrH2yL: 25,
        md6J5l8f: 30,
        '6Fp87sYT': 35,
        '0J1Y0pnG': 40
      }
    }
  },
}
</script>
<style scoped>
.icon-error {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  position: relative;
}

.icon-error::before,
.icon-error::after {
  content: '';
  position: absolute;
  width: 2px;
  height: 12px;
  background-color: white;
  top: 6px;
  left: 11px;
}

.icon-error::before {
  transform: rotate(45deg);
}

.icon-error::after {
  transform: rotate(-45deg);
}
</style>